var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_182_2620)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1397,
    cy: 20,
    rx: 20.1397,
    ry: 20,
    fill: "url(#paint0_linear_182_2620)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6613 8.99512C17.9976 8.99512 17.3612 9.25876 16.8919 9.72805L9.52036 17.0997C9.24116 17.3789 9.10156 17.7449 9.10156 18.1108C9.10156 18.4767 9.24117 18.8427 9.52037 19.1219L14.3512 23.9527V15.4004C14.3512 14.7622 14.8645 14.2448 15.5027 14.2448C18.1992 14.2448 24.7627 14.2448 25.658 14.2448L30.9076 8.99519L18.6613 8.99512Z",
    fill: "#4A21EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3512 25.5517H24.5024C25.1406 25.5517 25.658 25.0343 25.658 24.3961V15.8438L30.4888 20.6746C30.768 20.9538 30.9076 21.3197 30.9076 21.6857C30.9076 22.0517 30.768 22.4176 30.4888 22.6968L23.1172 30.0685C22.648 30.5377 22.0115 30.8014 21.3478 30.8014L9.10156 30.8013L14.3512 25.5517Z",
    fill: "#4A21EF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_182_2620",
    x: -20,
    y: -20,
    width: 80.2812,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_182_2620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_182_2620",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_182_2620",
    x1: 0,
    y1: 0,
    x2: 29.3546,
    y2: 46.8457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafepal);
export default __webpack_public_path__ + "static/media/safepal.e5827d1a5554cbc30e113f506d9b1117.svg";
export { ForwardRef as ReactComponent };